import Model from '@/Models/Model'

export default class CompanyPricing extends Model {
  /**
   * Resource
   *
   * @returns {string}
   */
  resource() {
    return 'company-management/pricing'
  }
}
